import React from "react";
import { Box, Typography, IconButton, Button } from "@mui/material";
import { X, Trash } from "phosphor-react";

const DeleteNavConfig = ({
  handleDeleteNavConfig,
  handleCloseModal,
  modalTitle,
  modalDescription,
}) => {
  return (
    <Box
      sx={{
        width: "450px",
        backgroundColor: "#252A38",
        borderRadius: "10px",
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "10px",
        }}
      >
        <Typography fontSize="16px !important">{modalTitle}</Typography>
        <IconButton onClick={() => handleCloseModal()}>
          <X size={16} color="#606479" />
        </IconButton>
      </div>
      <Typography color="#f9f9f9" fontSize="14px !important">
        {modalDescription}
      </Typography>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Button
          onClick={handleDeleteNavConfig}
          variant="contained"
          startIcon={<Trash size={16} />}
          sx={{
            backgroundColor: "#E41F1F",
            color: "#fff",
            textTransform: "none",
            "&:hover": { backgroundColor: "#E41F1F29", color: "#fff" },
          }}
        >
          Delete
        </Button>
      </div>
    </Box>
  );
};

export default DeleteNavConfig;
